import type { ComputedRef } from 'vue';

/**
 * Webshop store info for the active locale — centralizes the
 * `localeStoreMap` lookup and the `zh-cn` demo-shop special case that were
 * previously duplicated inline in `plugins/10.shop.ts`.
 */
export interface ActiveLocaleShopInfo {
  shopStore: string;
  hasWebshop: boolean;
}

const DEFAULT_SHOP_STORE = 'emea_en';

/**
 * True for locales that never have a real Magento webshop (only a demo
 * shop config), e.g. zh-cn.
 */
function hasNoWebshop(webappLocale: string): boolean {
  return webappLocale === 'zh-cn';
}

export function useActiveLocaleShopInfo(): ComputedRef<ActiveLocaleShopInfo> {
  const { $activeLocale } = useNuxtApp();
  const configuration = usePdpConfiguration();

  return computed<ActiveLocaleShopInfo>(() => {
    const webappLocale = $activeLocale.value.webapp;

    return {
      shopStore:
        configuration.value?.localeStoreMap?.[webappLocale] ??
        configuration.value?.localeStoreMap?.default ??
        DEFAULT_SHOP_STORE,
      hasWebshop: !hasNoWebshop(webappLocale)
    };
  });
}
